import { combineReducers } from "redux";
import tableReducer from "./tableReducer";
import ViewerReducer from "./viewerReducer";
import userReducer from "./userReducer";
const rootReducer = combineReducers({
  viewer: ViewerReducer,
  table: tableReducer,
  user: userReducer,
});

export default rootReducer;
